export default __webpack_public_path__ + "static/media/razorpay-icon.b48064bb.png";